import axios from 'axios'
import { getEndpoint } from 'common/backend/endpoints'

export const createInteractiveBudget = async (body) =>
    await axios.post(getEndpoint('INTERACTIVE_BUDGETS'), body)
